import { pdf, Font, Page, Text, View, Document, StyleSheet, Image } from '@react-pdf/renderer'
import logo from '../../assets/logo.png'
import side from '../../assets/side.png'
import robotoRegular from '../../assets/roboto/regular.ttf'
import robotoBold from '../../assets/roboto/bold.ttf'
import robotoLight from '../../assets/roboto/light.ttf'
import { getFecha } from '../helpers'

Font.register({ family: 'Roboto', fonts: [
  { src: robotoRegular },
  { src: robotoBold, fontWeight: 700 },
  { src: robotoLight, fontWeight: 300 },
]});

const css = StyleSheet.create({
  page: {
    flexDirection: 'row',
    backgroundColor: '#E4E4E4',
    fontFamily: 'Roboto'
  },
  side: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: 70,
    height: 842,
  },
  bold: {
    fontWeight: 700,
    textDecoration: 'underline',
  },
  section: {
    margin: 10,
    padding: 10,
    paddingLeft: 80,
    fontSize: 12,
  },
  logo: {
    height: 50,
    width: 216,
  },
  main: {
    fontSize: 16,
    marginTop: 10,
    marginBottom: 8,
  },
  element: {
    marginTop: 8,
    marginBottom: 8,
  },
  colorElement: {
    marginLeft: 20,
    marginTop: 8,
    marginBottom: 8,
    color: '#8cc63f'
  },
  subelement: {
    marginLeft: 20,
    marginBottom: 5,
  },
  detail: {
    fontSize: 11,
    lineHeight: 1.3,
    marginLeft: 20,
    marginBottom: 5,
    color: '#333',
  },
  signatures: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 20,
    marginBottom: 40,
  },
  signature: {
    fontSize: 10,
  },
  source: {
    height: 50,
    width: 125,
  },
}) 

const processPDF = ({ nombre, centro, fecha, firmaAlumno, firmaTutor })=> (
  <Document>
    <Page size="A4" style={css.page}>
      <Image fixed style={css.side} src={side} />
      <View style={css.section}>
        <Image style={css.logo} src={logo} />
        <Text style={css.main}>Hola {nombre},</Text>
        <Text style={css.main}>Bienvenido a mundoestudiante</Text>

        <View style={css.subsection}>
          <Text style={css.element}>Queremos agradecerte que hayas confiado en nosotros para que te ayudemos con tus estudios, ¡Estamos seguros de que vas a notarlo en tus resultados desde el primer momento!</Text>
          <Text style={css.element}>Tanto el equipo completo de profesores de mundoestudiante, así como el personal de administración, estamos a tu disposición para solucionarte cualquier duda o inquietud. ¡No dudes en preguntarnos!</Text>
        </View>

        <View style={css.subsection}>
          <Text style={css.colorElement}>¡Somos encantadores!</Text>
        </View>

        <View style={css.subsection}>
          <Text style={css.element}>Nuestro horario de clase es de lunes a jueves de 10:00 a a 14:00 y de 16:30 a 20:30, viernes y sábado de 10:00 a 14:00. Infórmate, ya que podemos tener modicaciones de horario.</Text>
          <Text style={css.element}>Aprovechamos también para recordarte que puedes seguirnos en las redes sociales y en nuestro blog para estar al día de un montón de contenido muy interesante para estudiantes.</Text>
        </View>

        <View style={css.subsection}>
          <Text style={css.element}>En tu academia, nuestros compañeros te atenderán encantados. También puedes contactarnos</Text>
          <Text style={css.subelement}>• Llamando por teléfono al <Text style={css.bold}>{centro.telefono}</Text></Text>
          <Text style={css.subelement}>• Enviando un WhatsApp al <Text style={css.bold}>{centro.whatsapp}</Text></Text>
          <Text style={css.subelement}>• Enviando un email a <Text style={css.bold}>hola@mundoestudiante.com</Text></Text>
        </View>

        <View style={css.subsection}>
          <Text style={css.element}>Por último, te indicamos el extracto de las condiciones de la RGPD para tu información:</Text>
          <Text style={css.detail}>
            De acuerdo con el Reglamento (UE) 2016/679 del Parlamento y del Consejo de abril de 2016 y 
            la Ley Orgánica 3/2018, de 5 de diciembre de Protección de Datos Personales y Garantía de 
            los Derechos Digitales, {centro.sociedad.nombre}, como responsable del tratamiento de tus datos, te 
            informamos de que trataremos la información que nos proporciones con el propósito de gestionar 
            tu inscripción. 
          </Text>
          <Text style={css.detail}>
            Tiene derecho a acceder, rectificar, oponerse, suprimir, solicitar la 
            portabilidad y limitar el tratamiento de sus datos personales, así como a presentar una 
            reclamación ante la AEPD. Para ejercer sus derechos, puede enviar un email 
            a: <Text style={css.bold}>administracion@mundoestudiante.com</Text>. 
          </Text>
          <Text style={css.detail}>
            Para obtener más información sobre el 
            tratamiento de sus datos y como ejercitar sus derechos visite la política de privacidad de 
            nuestra web, disponible en <Text style={css.bold}>https://www.mundoestudiante.com/politica-privacidad/</Text>.
          </Text>
      </View>

        <View style={css.signatures}>
          <View style={css.signature}>
            <Text>Firma de {nombre}</Text>
            <Image style={css.source} src={firmaAlumno} />
          </View>
          {firmaTutor && (
            <View style={css.signature}>
              <Text>Firma del tutor</Text>
              <Image style={css.source} src={firmaTutor} />
            </View>
          )}
        </View>

        <Text>Firmado en {centro.nombre}, el {fecha}</Text>
      </View>
    </Page>
  </Document>
)

export const getPDF = async ({ nombre, centro, firmaAlumno, firmaTutor })=> {
  const fecha = getFecha()
  const document = await processPDF({ nombre, centro, fecha, firmaAlumno, firmaTutor })
  const blob = await pdf(document).toBlob()
  return blob
}

export const downloadBlob = (blob)=> {
  const blobUrl = URL.createObjectURL(blob)
  // Create a link element
  const link = document.createElement("a")
  // Set link's href to point to the Blob URL
  link.href = blobUrl
  link.download = 'rgpd.pdf'
  // Append link to the body
  document.body.appendChild(link)
  // Dispatch click event on the link
  link.dispatchEvent(
    new MouseEvent('click', { 
      bubbles: true, 
      cancelable: true, 
      view: window 
    })
  )
  // Remove link from body
  document.body.removeChild(link)
}